import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Question from "./Question";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as FormActionCreator from "../../../redux/creators/form";
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import { translate } from "../../base/Translation";

const SortableItem = SortableElement(({data}) =>
	<div><Question question={data.question} section={data.section} group={data.group} updateQuestion={data.updateQuestion} /></div>
);

const SortableList = SortableContainer(({items}) => {
	return (
		<div>
			{items.map((data, index) => (
				<SortableItem key={data.question.id} index={index} data={data} />
			))}
		</div>
	);
});

class Questions extends React.Component {

	componentDidMount() {
		this.shouldUpdate = false;
	}


	addQuestion() {
		this.shouldUpdate = true;

		this.props.addQuestion({
			id: -Math.random(),
			name: "",
			note: "",
			note_internal: "",
			required: true,
			irrelevant: false,
			irrelevant_note: "",
			bonus: false,
			type: "radio",
			question_possible_answers: []
		}, this.props.section, this.props.group);
	}

	onSortEnd = ({oldIndex, newIndex}) => {
		let newOrder = arrayMove(this.props.questions, oldIndex, newIndex);
		this.props.reorderQuestions(newOrder, this.props.section, this.props.group);
	};


	render() {

		this.shouldUpdate = false;

		let questions = this.props.questions.map(function (question) {
			return {
				question: question,
				section: this.props.section,
				group: this.props.group,
				updateQuestion: this.props.updateQuestion
			};
		}.bind(this));

		return (
			<div>
				<Row>
					<Col lg={12}>
						<SortableList items={questions} onSortEnd={this.onSortEnd} pressDelay={1000} />
					</Col>
				</Row>
				<Row>
					<Col lg={12}>
						<button className="btn btn-primary btn-sm" onClick={this.addQuestion.bind(this)}>{translate("Pridať otázku")}</button>
					</Col>
				</Row>
			</div>
		)
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ 
		addQuestion: FormActionCreator.addQuestionAction, 
		reorderQuestions: FormActionCreator.reorderQuestions,
		updateQuestion: FormActionCreator.updateQuestionAction
	}, dispatch);
}

export default connect(state => ({ form: state.form }), matchDispatchToProps)(Questions);


// WEBPACK FOOTER //
// ./src/modules/form/edit/Questions.js